
<div class="task">
    <div class="flex justify-content-center">
        <ng-content></ng-content>
    </div>
</div>

